import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { loginJson } from '@/lib/api';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Mail, Lock } from 'lucide-react';
import { toast } from 'sonner';

export function LoginPage() {
    const navigate = useNavigate();
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [loading, setLoading] = useState(false);
    
    // Check if already logged in
    useEffect(() => {
        const token = localStorage.getItem('auth_token');
        if (token) {
            navigate('/admin');
        }
    }, [navigate]);
    
    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        
        try {
            const response = await loginJson(email, password);
            localStorage.setItem('auth_token', response.data.access_token);
            localStorage.setItem('auth_user', JSON.stringify(response.data.user));
            toast.success(`Willkommen, ${response.data.user.vorname}!`);
            navigate('/admin');
        } catch (error) {
            toast.error(error.response?.data?.detail || 'Login fehlgeschlagen');
        } finally {
            setLoading(false);
        }
    };
    
    return (
        <div className="min-h-screen bg-gradient-to-br from-slate-50 to-slate-100 flex items-center justify-center p-4">
            <div className="w-full max-w-md">
                <div className="bg-white rounded-3xl shadow-xl p-8">
                    <div className="text-center mb-8">
                        <img src="/logo.svg" alt="Musikschule Logo" className="w-20 h-20 mx-auto mb-4 object-contain" />
                        <h1 className="text-2xl font-bold text-gray-900">Admin Login</h1>
                        <p className="text-gray-500 mt-2">Musikschule - Woche des offenen Unterrichts</p>
                    </div>
                    
                    <form onSubmit={handleSubmit} className="space-y-6">
                        <div className="space-y-2">
                            <Label htmlFor="email" className="text-base">E-Mail</Label>
                            <div className="relative">
                                <Mail className="absolute left-4 top-1/2 -translate-y-1/2 w-5 h-5 text-gray-400" />
                                <Input
                                    id="email"
                                    type="email"
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                    className="pl-12 h-14 text-base rounded-xl"
                                    placeholder="admin@musikschule.at"
                                    autoFocus
                                />
                            </div>
                        </div>
                        
                        <div className="space-y-2">
                            <Label htmlFor="password" className="text-base">Passwort</Label>
                            <div className="relative">
                                <Lock className="absolute left-4 top-1/2 -translate-y-1/2 w-5 h-5 text-gray-400" />
                                <Input
                                    id="password"
                                    type="password"
                                    value={password}
                                    onChange={(e) => setPassword(e.target.value)}
                                    className="pl-12 h-14 text-base rounded-xl"
                                    placeholder="••••••••"
                                />
                            </div>
                        </div>
                        
                        <Button 
                            type="submit" 
                            className="w-full h-14 text-lg rounded-xl"
                            disabled={!email || !password || loading}
                        >
                            {loading ? 'Anmelden...' : 'Anmelden'}
                        </Button>
                    </form>
                </div>
            </div>
        </div>
    );
}

export default LoginPage;
